import { getOrCreateSessionId, getSessionId, setSessionId } from './sessionStorage';
import { createMonkeybookSession } from './sessionData';
import { SessionOrigin, SessionService } from '../api';

const sendSessionToBackend = (
  accountId: string,
  sessionData: ReturnType<typeof createMonkeybookSession>,
  origin: SessionOrigin,
) => {
  SessionService.createSessionInternal({
    account_id: accountId,
    origin,
    ...sessionData,
  }).catch((error) => {
    console.error('[Monkeybook] Error sending session data:', error);
  });
};

export const initializeSession = (accountId: string, origin: SessionOrigin): string => {
  const urlSessionId = new URLSearchParams(window.location.search).get('session_id');
  if (urlSessionId) {
    setSessionId(urlSessionId);
    return urlSessionId;
  }

  const existingSessionId = getSessionId();
  if (!existingSessionId) {
    const sessionData = createMonkeybookSession();
    sendSessionToBackend(accountId, sessionData, origin);
    return sessionData.session_id;
  }
  return getOrCreateSessionId();
};

export const getSessionIdSync = (): string | null => {
  return getSessionId();
};
